module.exports = __webpack_public_path__ + "img/app-mockup-record.4b837599.png";